import React, { useState, useEffect } from "react";
import data from "../data/data.json"; 
import "../assets/css/header.css";

export const Header = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = data.Header;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds
    return () => clearInterval(interval);
  }, [slides.length]);

  const getBackgroundImage = (index) => {
    return require(`../assets/Hero/hero_${index + 1}.png`);
  };

  const handlePrevSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === 0 ? slides.length - 1 : prevSlide - 1
    );
  };

  const handleNextSlide = () => {
    setCurrentSlide((nextSlide) =>
      nextSlide === slides.length - 1 ? 0 : nextSlide + 1
    );
  };

  const handleButtonClick = (index, link) => {
    setCurrentSlide(index);
    window.location.href = link; // Redirects to the specified link
  };

  return (
    <header id="header">
      <div
        className="intro"
        style={{
          backgroundImage: `url(${getBackgroundImage(currentSlide)})`,
        }}
      >
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {slides[currentSlide].title}
                  <span></span>
                </h1>
                <p>{slides[currentSlide].paragraph}</p>
                <a href="#features" className="btn btn-custom btn-lg page-scroll">
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Left and Right Scroll Buttons */}
        <button className="scroll-button left" onClick={handlePrevSlide}>
          &#10094;
        </button>
        <button className="scroll-button right" onClick={handleNextSlide}>
          &#10095;
        </button>

        {/* Small Scroll Bars */}
        <div className="scroll-indicators">
          {slides.map((slide, index) => (
            <button
              key={index}
              className={`scroll-dot ${
                currentSlide === index ? "active" : ""
              }`}
              onClick={() => handleButtonClick(index, slide.link)}
            ></button>
          ))}
        </div>
      </div>
    </header>
  );
};
